import { render, staticRenderFns } from "./ReceivedBillAmount.vue?vue&type=template&id=2b672b05&scoped=true&"
import script from "./ReceivedBillAmount.vue?vue&type=script&lang=js&"
export * from "./ReceivedBillAmount.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedBillAmount.vue?vue&type=style&index=0&id=2b672b05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b672b05",
  null
  
)

export default component.exports